module.exports = __webpack_public_path__ + "static/media/check-green.44d856a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/check-green.svg
// module id = 1296
// module chunks = 0